import Contacts from "pages/contacts";
import ContactDetails from "pages/contacts/components/ContactDetails";
import CreateContact from "pages/contacts/components/CreateContact";
import EditContact from "pages/contacts/components/EditContact";
import Dashboard from "pages/dashboard";
import Leads from "pages/leads";
import CreateLead from "pages/leads/components/CreateLead";
import LeadDetails from "pages/leads/components/LeadDetails";
import Properties from "pages/properties";
import Villas from "pages/villas";
import Projects from "pages/projects";
import CreateProperty from "pages/properties/components/CreateProperty";
import CreateVilla from "pages/villas/components/CreateProperty";
import CreateProject from "pages/projects/components/CreateProperty";
import EditProperty from "pages/properties/components/EditProperty";
import EditVilla from "pages/villas/components/EditProperty";
import EditProject from "pages/projects/components/EditProperty";
import Todo from "pages/todo";
import Staff from "pages/staff";
import CreateStaff from "pages/staff/components/CreateStaff";

export const ROUTES = [
  {
    path: "/",
    element: <Dashboard />,
    onNav: {
      icon: "bi bi-grid",
      text: "Dashboard",
    },
  },
  {
    path: "/todo-list",
    element: <Todo />,
    onNav: {
      icon: "bi bi-clipboard-check",
      text: "Todo list",
    },
  },
  {
    onNav: {
      icon: "bi bi-people",
      text: "Contacts",
    },
    children: [
      {
        path: "/contacts/create-contact",
        element: <CreateContact />,
        onNav: {
          icon: "bi bi-dot",
          text: "Create Contact",
        },
      },
      {
        path: "/contacts",
        element: <Contacts />,
        onNav: {
          icon: "bi bi-dot",
          text: "All Contacts",
        },
      },
      {
        path: "/contact-details/:id",
        element: <ContactDetails />,
      },
      {
        path: "/contact/:id",
        element: <EditContact />,
      },
    ],
  },
  {
    onNav: {
      icon: "bi bi-buildings",
      text: "Properties",
    },
    children: [
      {
        path: "/properties/create-property",
        element: <CreateProperty />,
        onNav: {
          icon: "bi bi-dot",
          text: "Create Property",
        },
      },
      {
        path: "/properties",
        element: <Properties />,
        onNav: {
          icon: "bi bi-dot",
          text: "All Properties",
        },
      },
      {
        path: "/property/:id",
        element: <EditProperty />,
      },
    ],
  },
  {
    onNav: {
      icon: "bi bi-houses",
      text: "Villas",
    },
    children: [
      {
        path: "/villas/create-villa",
        element: <CreateVilla />,
        onNav: {
          icon: "bi bi-dot",
          text: "Create Villa",
        },
      },
      {
        path: "/villa/:id",
        element: <EditVilla />,
      },
      {
        path: "/villas",
        element: <Villas />,
        onNav: {
          icon: "bi bi-dot",
          text: "All Villas",
        },
      },
    ],
  },
  {
    onNav: {
      icon: "bi bi-building",
      text: "Projects",
    },
    children: [
      {
        path: "/projects/create-project",
        element: <CreateProject />,
        onNav: {
          icon: "bi bi-dot",
          text: "Create Project",
        },
      },
      {
        path: "/project/:id",
        element: <EditProject />,
      },
      {
        path: "/projects",
        element: <Projects />,
        onNav: {
          icon: "bi bi-dot",
          text: "All Projects",
        },
      },
    ],
  },
  {
    onNav: {
      icon: "bi bi-kanban",
      text: "Lead Management",
    },
    children: [
      {
        path: "/lead-management/create-lead",
        element: <CreateLead />,
        onNav: {
          icon: "bi bi-dot",
          text: "Create Lead",
        },
      },
      {
        path: "/leads",
        element: <Leads />,
        onNav: {
          icon: "bi bi-dot",
          text: "All Leads",
        },
      },
      {
        path: "/today-lead-followup",
        element: <Dashboard />,
        onNav: {
          icon: "bi bi-dot",
          text: "Today Lead Followup",
        },
      },
      {
        path: "/lead-details/:id",
        element: <LeadDetails />,
      },
    ],
  },
  {
    onNav: {
      icon: "bi bi-person-gear",
      text: "Staff Management",
    },
    children: [
      {
        path: "/staff-management/create-member",
        element: <CreateStaff />,
        onNav: {
          icon: "bi bi-dot",
          text: "Create Member",
        },
      },
      {
        path: "/staff",
        element: <Staff />,
        onNav: {
          icon: "bi bi-dot",
          text: "All Members",
        },
      },
    ],
  },
];
